import React, { useState } from 'react';
import { useNavigate } from 'react-router';

import { Button, Form, Modal } from 'react-bootstrap';

export default (props) => {
    const [showModal, setShowModal] = useState(false);
    let navigate = useNavigate();

    return (
        <>
            <section id="header" className="d-flex align-items-sm-center">
                <div className="row text-white justify-content-center">
                    <div className="col-12 col-sm-5 ml-sm-5 mt-5 mt-sm-0">
                        <h1 className="text-center text-sm-left">YOUR TOTAL HOME PROTECT SOLUTION</h1>
                    </div>
                </div>
            </section>
            <section id="body">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="row shadow title mt-n5 position-relative justify-content-center">
                                <div className="col-4 col-sm-2 align-self-center text-right py-3">
                                    <img src="../images/hho-icon.png" alt="Houseowner &amp; Householder Insurance" width={120} />
                                </div>
                                <div className="col-8 col-sm-6 align-self-center text-center">
                                    <h1 className="my-5 mr-sm-5 text-white font-weight-bold">EZ HOMEPROTECT</h1>
                                </div>
                            </div>
                            <div className="row content">
                                <div className="col-1"></div>
                                <div className="col-10 shadow bg-white rounded">
                                    <div className="row text-primary mt-4 px-5 py-3">
                                        <div className="col-12 mt-1 text-center">
                                            <p>
                                                Peace of mind, be it for your home or rental property, contents as well as personal effects based on
                                                your needs and wants. Protecting your home can be an easy decision.
                                            </p>
                                            <p className="text-blue">
                                                <i className="fas fa-check-circle text-primary mr-2"></i>
                                                Coverage against damage caused by fire, lightning, and domestic explosions, flood and landslides
                                            </p>
                                            <hr className="mx-2 mx-sm-5" />
                                            <p className="text-blue">
                                                <i className="fas fa-check-circle text-primary mr-2"></i>
                                                Coverage against theft, robbery and hold-ups
                                            </p>
                                            <hr className="mx-2 mx-sm-5" />
                                            <p className="text-blue">
                                                <i className="fas fa-check-circle text-primary mr-2"></i>
                                                Coverage for landlords
                                            </p>
                                        </div>
                                    </div>
                                    <div className="row d-none d-sm-flex mb-3">
                                        <div className="col-12 text-right">
                                            <small>* Terms and conditions apply.</small>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-12 text-center">
                                            <p className="pdpa small">
                                                By clicking 'Get Quote' button, you have read and agreed to our <a href={process.env.MIX_INSTAPOL_DOMAIN + "/privacy-policy"}>Privacy Policy</a>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-1"></div>
                            </div>
                            <div className="row footer text-center mt-n3">
                                <div className="col-12">
                                    <Button type="button" variant="success" onClick={() => { setShowModal(true); }}>Get Quote</Button>
                                    <ShowBasicInfoPopup
					referral={props.referral}
                                        showModal={showModal} setShowModal={setShowModal}
                                        setBasicName={props.setBasicName}
                                        setBasicEmailAdd={props.setBasicEmailAdd}
                                        setBasicContactNo={props.setBasicContactNo}
                                        navigate={navigate}
                                    />
                                </div>
                            </div>
                            <div className="row d-flex d-sm-none mt-3">
                                <div className="col-12 text-center">
                                    <small>* Terms and conditions apply.</small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row pds text-white mt-5">
                        <div className="col-12">
                            <div className="row">
                                <div className="col-12 text-center">
                                    <p className="my-4 font-weight-bold">Please review the Product Disclosure Sheet and Policy Wording prior to purchase to ensure it meets your requirements.</p>
                                </div>
                            </div>
                            <div className="row pds-row my-5 justify-content-center">
                                <div className='col-sm-6'>
                                    <div className='row'>
                                <div className="col-12 col-sm-6">
                                    <a href="storage/pdf/Tune Protect Home Shield (Product Disclosure Sheet).pdf" target="_blank" className="text-white text-decoration-none">
                                        <div className="pdf-icon">
                                            <img src="../images/tuneprotect.png" alt="Tune Protect Home Shield (Product Disclosure Sheet).pdf" className="img" width={80} />
                                        </div>
                                        <div>Tune Protect Home Shield</div>
                                        <div>(Product Disclosure Sheet)</div>
                                    </a>
                                </div>
                                <div className="col-12 col-sm-6">
                                    <a href="storage/pdf/Tune Protect Home Shield (Policy Wordings).pdf" target="_blank" className="text-white text-decoration-none">
                                        <div className="pdf-icon">
                                            <img src="../images/tuneprotect.png" alt="Tune Protect Home Shield (Policy Wordings).pdf" className="img" width={80} />
                                        </div>
                                        <div>Tune Protect Home Shield</div>
                                        <div>(Policy Wording)</div>
                                    </a>
                                </div>

                                    </div>
                                </div>
                                <div className='col-sm-6'>
                                    <div className='row'>
                                <div className="col-12 col-sm-6">
                                    <a href="storage/pdf/PDS_LIBERTY.pdf" target="_blank" className="text-white text-decoration-none">
                                        <div className="pdf-icon">
                                            <img src="../images/liberty.png" alt="Liberty Householder Plus (Product Disclosure Sheet).pdf" className="img" width={80} />
                                        </div>
                                        <div>Liberty Insurance Householder Plus</div>
                                        <div>(Product Disclosure Sheet)</div>
                                    </a>
                                </div>
                                <div className="col-12 col-sm-6">
                                    <a href="storage/pdf/LIBERTY.pdf" target="_blank" className="text-white text-decoration-none">
                                        <div className="pdf-icon">
                                            <img src="../images/liberty.png" alt="Liberty Householder Plus (Policy Wordings).pdf" className="img" width={80} />
                                        </div>
                                        <div>Liberty Insurance Householder Plus</div>
                                        <div>(Policy Wording)</div>
                                    </a>
                                </div>

                                    </div>
                                    <p className='text-center mt-3' style={{ fontSize: '15px' }}>Underwritten by Liberty General Insurance Berhad</p>
                                </div>              
                            </div>
                        </div>
                    </div>
            </section>
        </>
    );
}

function ShowBasicInfoPopup(props) {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [contact, setContact] = useState('');

    function onClickNext(e) {
        e.preventDefault();
        e.stopPropagation();

        props.setBasicName(name);
        props.setBasicEmailAdd(email);
        props.setBasicContactNo(contact);
        props.setShowModal(false);

        axios.post('/api/basic-info', {
            name: name,
            email: email,
            contact: contact
        }).then(() => {
 
props.navigate(
    props.referral
        ? `/HHO?r=${encodeURIComponent(props.referral)}`
        : '/HHO'
);

        });
    }

    return (
        <Modal show={props.showModal} onHide={() => props.setShowModal(false)} size="lg" centered>
            <Modal.Header closeButton>
                <div className="col-11 text-center">
                    <img src="../images/new-logo-02.png" className="img ml-5" width={120} />
                </div>
            </Modal.Header>
            <Form onSubmit={(e) => { onClickNext(e); }}>
                <Modal.Body>
                      <div className="mb-3 row">
                        <label className="col-5 col-form-label">Name</label>
                        <div className="col-7">
                            <input type="text" className="form-control" placeholder='Full name as per NRIC' required value={name} onChange={(e) => setName(e.target.value)} />
                        </div>
                    </div>
                     <div className="mb-3 row">
                        <label className="col-5 col-form-label">Mobile</label>
                        <div className="col-7">
                            <input type="text" className="form-control" required value={contact} onChange={(e) => setContact(e.target.value)} pattern="\d*" maxLength="11" placeholder="012xxxxxxxx" />
                        </div>
                    </div>
                     <div className="mb-3 row">
                        <label className="col-5 col-form-label">Email</label>
                        <div className="col-7">
                            <input type="email" className="form-control" placeholder='abc@gmail.com' required value={email} onChange={(e) => setEmail(e.target.value)} />
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <div className="form-group row text-right">
                        <div className="col-12">
                            <Button type="submit" variant="success">Continue</Button>
                        </div>
                    </div>
                </Modal.Footer>
            </Form>
        </Modal>
    );
}
